import { petOwnerFail } from './../consultation.actions';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, tap } from 'rxjs/operators';
import { toggleLoader } from '@app/store/core';
import { RcToastTypes } from '@app/core/models/toast';
import { CoreFacade } from '@app/store/core/core.facade';
import { Helper } from '@app/shared/utils';

@Injectable()
export class PetOwnerEffects {
  /**
   * Pet owner generic fail
   */
  public petOwnerFail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(petOwnerFail),
      tap(({ error }) => {
        return this.coreFacade.setToast({
          id: Helper.randomId(),
          title: $localize`:@@error_general_title:`,
          description: error,
          dataQa: 'vs-consultation-pet-owner-page-toast-error',
          type: RcToastTypes.Error,
        });
      }),
      switchMap(() => [toggleLoader({ value: false })]),
    ),
  );

  constructor(
    private actions$: Actions,
    private readonly coreFacade: CoreFacade,
  ) {}
}
